import React from "react";
import Button from "app/components/Button";

export default function TicketActions({
  onCancel,
  onSave,
  disabled,
  loading,
  EnterIcon,
}: any) {
  return (
    <>
      <button
        className="flex items-center justify-center h-[28px] rounded-[4px] border border-[#E9ECF2] text-xs font-medium text-secondary px-[10px] hover:bg-[#ECEEF2] hover:text-[#79808A] transition-all"
        onClick={onCancel}
      >
        Cancel
      </button>
      <Button
        className="flex items-center justify-center h-[28px] rounded-[4px] text-xs font-medium px-[10px] gap-1"
        disabled={disabled}
        onClick={onSave}
        isLoading={loading}
        disabledClassName="!bg-primary !opacity-50"
      >
        Save <img src={EnterIcon} alt="enter-icon" sizes="20px" />
      </Button>
    </>
  );
}
